// src/ConsumerApp/utils/guestBucketManager.js

const GUEST_BUCKET_KEY = 'bb_guest_bucket';
const GUEST_EVENT_NAME = 'guest-bucket-change';

export const guestBucketManager = {
  getItems: () => {
    try {
      const stored = localStorage.getItem(GUEST_BUCKET_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  },

  getQuantityMap: () => {
    const items = guestBucketManager.getItems();
    const map = new Map();
    items.forEach((item) => {
      const pid = String(item.product_id || item.item_id || item._id);
      map.set(pid, Number(item.quantity) || 1);
    });
    return map;
  },

  getTotalCount: () => {
    const items = guestBucketManager.getItems();
    return items.length;
  },

  addItem: (product, qty) => {
    const items = guestBucketManager.getItems();
    const pid = String(product.product_id || product.item_id || product._id);
    const existingIndex = items.findIndex(
      (i) => String(i.product_id || i.item_id || i._id) === pid
    );

    const initialQty = qty || product.buy_now?.min_qty || product.min_qty || 1;
    const resolvedName = product.product_name || product.item_name || product.name || 'Construction Material';
    const resolvedImage = product.product_image_url || product.product_image || product.item_image || product.image;
    const resolvedBrand = product.brand_name || product.brand || '';
    const resolvedUom = product.uom || product.uom_name || product.UOM || 'Unit';
    const resolvedUnitPrice = Number(product.buy_now?.unit_price || product.selling_price || product.price || product.unit_price || 0);
    const resolvedMrp = Number(product.mrp || 0);

    if (existingIndex > -1) {
      items[existingIndex].quantity = initialQty;
      items[existingIndex].item_total = initialQty * resolvedUnitPrice;
      items[existingIndex].item_mrp_total = initialQty * resolvedMrp;
    } else {
      items.push({
        // Identifiers
        product_id: pid,
        item_id: pid,
        _id: pid,

        // Title/Name mapped for both ProductCard and BucketItemCard
        item_name: resolvedName,
        product_name: resolvedName,
        name: resolvedName,

        // Brand & Unit mapped for BucketItemCard
        brand: resolvedBrand,
        brand_name: resolvedBrand,
        uom_name: resolvedUom,
        UOM: resolvedUom,
        uom: resolvedUom,

        // Images mapped for BucketItemCard & ProductCard
        item_image: resolvedImage,
        product_image: resolvedImage,
        product_image_url: resolvedImage,

        // Pricing & Totals
        unit_price: resolvedUnitPrice,
        price: resolvedUnitPrice,
        item_total: initialQty * resolvedUnitPrice,
        mrp: resolvedMrp,
        item_mrp_total: initialQty * resolvedMrp,

        // Quantities
        min_qty: Number(product.buy_now?.min_qty || product.min_qty || 1),
        max_qty: Number(product.buy_now?.max_qty || product.max_qty || 999),
        quantity: initialQty,
        purchase_type: 'BUY_NOW',
      });
    }

    localStorage.setItem(GUEST_BUCKET_KEY, JSON.stringify(items));
    window.dispatchEvent(new Event(GUEST_EVENT_NAME));
  },

  updateQuantity: (productId, nextQty) => {
    const pid = String(productId);
    const items = guestBucketManager.getItems();
    const existingIndex = items.findIndex(
      (i) => String(i.product_id || i.item_id || i._id) === pid
    );

    if (existingIndex > -1) {
      const unitPrice = Number(items[existingIndex].unit_price || items[existingIndex].price || 0);
      const mrp = Number(items[existingIndex].mrp || 0);

      items[existingIndex].quantity = nextQty;
      items[existingIndex].item_total = nextQty * unitPrice;
      items[existingIndex].item_mrp_total = nextQty * mrp;

      localStorage.setItem(GUEST_BUCKET_KEY, JSON.stringify(items));
      window.dispatchEvent(new Event(GUEST_EVENT_NAME));
    }
  },

  removeItem: (productId) => {
    const pid = String(productId);
    const items = guestBucketManager
      .getItems()
      .filter((i) => String(i.product_id || i.item_id || i._id) !== pid);

    localStorage.setItem(GUEST_BUCKET_KEY, JSON.stringify(items));
    window.dispatchEvent(new Event(GUEST_EVENT_NAME));
  },

  clearGuestBucket: () => {
    localStorage.removeItem(GUEST_BUCKET_KEY);
    window.dispatchEvent(new Event(GUEST_EVENT_NAME));
  },
};